import React from "react";

const LocationSVG = ({ height, width, fill = "none" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 28 28"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="28" rx="4" fill="#F5F7FF" />
      <path
        d="M19.3333 12.6673C19.3333 15.996 15.6406 19.4627 14.4006 20.5333C14.2851 20.6202 14.1445 20.6672 14 20.6672C13.8554 20.6672 13.7148 20.6202 13.5993 20.5333C12.3593 19.4627 8.66663 15.996 8.66663 12.6673C8.66663 11.2528 9.22853 9.89628 10.2287 8.89608C11.2289 7.89589 12.5855 7.33398 14 7.33398C15.4144 7.33398 16.771 7.89589 17.7712 8.89608C18.7714 9.89628 19.3333 11.2528 19.3333 12.6673Z"
        stroke="#6570FC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 14.666C15.1046 14.666 16 13.7706 16 12.666C16 11.5614 15.1046 10.666 14 10.666C12.8954 10.666 12 11.5614 12 12.666C12 13.7706 12.8954 14.666 14 14.666Z"
        stroke="#6570FC"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LocationSVG;
